import { Injectable } from '@angular/core';

@Injectable()
export class ThemesService {

    styleTag: any;
    defaultTheme: string = 'A';

    constructor() {
        this.createStyle();
        this.setTheme(this.defaultTheme);
    }

    private createStyle() {
        const head = document.head || document.getElementsByTagName('head')[0];
        this.styleTag = document.createElement('link');
        this.styleTag.rel = 'stylesheet';
        this.styleTag.id = 'appthemes';
        head.appendChild(this.styleTag);
    }

    setTheme(name) {
        // Instead of using require, we'll use the compiled CSS files
        const themeName = `theme-${name.toLowerCase()}`;
        this.styleTag.href = `assets/css/${themeName}.css`;
    }

    getDefaultTheme() {
        return this.defaultTheme;
    }
}